import { useAtomValue } from "jotai"
import { useEffect } from "react";
import { paymentStore } from "store/paymentStore";

export const usePaymentList = () => {
    const paymentListState = useAtomValue(paymentStore.paymentList.stateAtom);

    useEffect(() => {
        return () => {
            paymentStore.paymentList.onDefault();
        }
    }, []);

    return {
        status: paymentListState.status,
        data: paymentListState.data,
        error: paymentListState.error
    };
}

export const usePaymentDetail = () => {
    const paymentDetailState = useAtomValue(paymentStore.paymentDetail.stateAtom);

    useEffect(() => {
        return () => {
            paymentStore.paymentDetail.onDefault();
        }
    }, []);

    return {
        status: paymentDetailState.status,
        data: paymentDetailState.data,
        error: paymentDetailState.error
    };
}

export const useCreatePayment = () => {
    const createPaymentState = useAtomValue(paymentStore.createPayment.stateAtom);

    useEffect(() => {
        return () => {
            paymentStore.createPayment.onDefault();
        }
    }, []);

    return {
        status: createPaymentState.status,
        data: createPaymentState.data,
        error: createPaymentState.error
    };
}

export const useRequestPayment = () => {
    const requestPaymentState = useAtomValue(paymentStore.requestPayment.stateAtom);

    useEffect(() => {
        return () => {
            paymentStore.requestPayment.onDefault();
        }
    }, []);

    return {
        status: requestPaymentState.status,
        data: requestPaymentState.data,
        error: requestPaymentState.error
    };
}

export const useReceiptOcr = () => {
    const receiptOcrState = useAtomValue(paymentStore.receiptOcr.stateAtom);

    useEffect(() => {
        return () => {
            paymentStore.receiptOcr.onDefault();
        }
    }, []);

    return {
        status: receiptOcrState.status,
        data: receiptOcrState.data,
        error: receiptOcrState.error
    };
}
